// import { useEffect, useContext } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { AuthContext } from "context";

// function FederatedSuccess() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const authContext = useContext(AuthContext);

//   useEffect(() => {
//     const queryParams = new URLSearchParams(location.search);
//     const token = queryParams.get("token");
//     console.log("Token from google : ", token);

//     if (token) {
//       authContext.login(token, token); // Use same token for both, like in backend
//       // navigate("/dashboard");
//     } else {
//       navigate("/auth/login");
//     }
//   }, [location, authContext, navigate]);

//   return <div>Logging you in...</div>;
// }

// export default FederatedSuccess;

// #######################################################################

import { useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "context";

function FederatedSuccess() {
  const navigate = useNavigate();
  const location = useLocation();
  const authContext = useContext(AuthContext);

  // Use Ref to ensure the token is processed only once
  const hasProcessedToken = useRef(false);

  useEffect(() => {
    // 1. If we are ALREADY authenticated, go to dashboard immediately.
    // This catches the case where the state updates successfully.
    if (authContext.isAuthenticated) {
      navigate("/dashboard", { replace: true });
      return;
    }

    // 2. Determine if we need to process the token
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    if (token) {
      if (!hasProcessedToken.current) {
        console.log("Token found, logging in...");
        hasProcessedToken.current = true;
        authContext.login(token, token);
        // We DO NOT navigate here. We wait for the checking
        // of isAuthenticated in the next render cycle (at the top of this effect).
      }
    } else {
      // No token and not authenticated? Go back to login.
      navigate("/auth/login");
    }

  }, [location, authContext.isAuthenticated, navigate, authContext]); // Add authContext.isAuthenticated to dependency array

  return <div>Logging you in...</div>;
}

export default FederatedSuccess;